import { IonLoading } from '@ionic/react'
import { authContext } from 'contexts'
import './spid.scss'
import BasePage from 'pages/base-page/base-page.page'
import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Redirect } from 'react-router'
import { profileService, routeService } from 'services'

const Spid: React.FC = () => {
  const auth = useContext(authContext)
  const [loading, setLoading] = useState(false)
  const [redirect, setRedirect] = useState<string | undefined>(undefined)
  const { t } = useTranslation()

  const success = (res: any) => {
    auth?.saveTokens(res.accessToken, res.refreshToken, res.changeToken)
    setLoading(false)
    if (auth?.getUserData()?.tipoProfilo.id === 'X') {
      setRedirect(routeService.generateRoutePath('/complete-reg'))
    } else {
      setRedirect(routeService.generateRoutePath('/'))
    }
  }
  const error = () => {
    !auth?.user && auth?.removeTokens()
    setLoading(false)
    setRedirect(routeService.generateRoutePath('/error'))
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')
    if (!!token) {
      setLoading(true)
      profileService.loginByMi(token, success, error)
    } else {
      setRedirect(routeService.generateRoutePath('/error'))
    }
  }, [])

  if (!!redirect) {
    return <Redirect to={redirect}></Redirect>
  }

  return (
    <BasePage>
      <IonLoading isOpen={loading} message={t('loading')} />
    </BasePage>
  )
}

export default Spid
